import {
    Box
} from "@chakra-ui/react";

import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client"

import { ThreeDots } from "react-loader-spinner";
import { ApiFetchDashboard } from "api/dashboards/dashboard";
import { Dashboard } from "api/types";
import { useState, useEffect } from "react";

export const IframeDashboard = (props: { dashboard: Dashboard, isFullscreen: boolean }) => {

    const { dashboard, isFullscreen } = props
    return (
        <Box
            position="relative"
            width="100%"
            height={
                {
                    md: isFullscreen ? "75vh" : "calc(100vh - 195px)",
                    lg: isFullscreen ? "88vh" : "calc(100vh - 200px)",
                    xl: isFullscreen ? "90vh" : "calc(100vh - 215px)",
                    '2xl': isFullscreen ? "90vh" : "calc(100vh - 220px)",
                }
            }
            borderRadius="20px"
        >
            <Box
                as={'iframe'}
                title={dashboard.name}
                width="100%"
                height="100%"
                borderRadius="20px"
                src={dashboard.publishedUrl}
            />
            <Box
                position="absolute"
                bottom="0"
                left="0"
                right="0"
                height="40px"
                backgroundColor="#111c44"
                borderBottomRadius="18px"
                zIndex="2"
            />
        </Box>
    )
}

export const EmbedDashboard = (props: { dashboard: Dashboard, isFullscreen: boolean }) => {

    const { dashboard, isFullscreen } = props
    const [embedSettings, setEmbedSettings] = useState(null)
    const [isLoading, setLoading] = useState(true)

    const getDashboardEmbedSettings = async () => ApiFetchDashboard(dashboard.id).then(
        (response) => {
            setEmbedSettings(response.data)
        }
    )

    const eventHandlers = new Map([
        ['loaded', function () { console.log('Report Loaded'); }],
        ['rendered', function () { setLoading(false); console.log('Report Rendered') }],
        ['error', function (event: any) { console.log(event.detail); }],
    ])

    useEffect(() => {
        getDashboardEmbedSettings();
    }, []);

    return (
        <Box
            height={
                {
                    md: isFullscreen ? "75vh" : "calc(100vh - 195px)",
                    lg: isFullscreen ? "88vh" : "calc(100vh - 200px)",
                    xl: isFullscreen ? "90vh" : "calc(100vh - 215px)",
                    '2xl': isFullscreen ? "90vh" : "calc(100vh - 220px)",
                }
            }>
            <ThreeDots
                visible={isLoading}
                height={isFullscreen ? "98vh" : "calc(100vh - 170px)"}
                width="70"
                wrapperClass="dashboard-dot-loader"
                color="#7551ff"
            />
            {
                embedSettings ?
                    <Box
                        title={dashboard.name}
                        width="100%"
                        height="100%"
                        borderRadius="20px"
                    >
                        <Box
                            height='10px'
                            position='relative'
                            zIndex='2'
                            top='-15px'
                            backgroundColor='#111c44'
                        />
                        <PowerBIEmbed
                            embedConfig={
                                {
                                    type: 'report',
                                    id: dashboard.powerBIReportUUID,
                                    tokenType: models.TokenType.Embed,
                                    settings: {
                                        filterPaneEnabled: false,
                                        navContentPaneEnabled: false
                                    },
                                    ...embedSettings.embed_config
                                }
                            }
                            eventHandlers={eventHandlers}
                            cssClassName="powerbi-report"
                        />
                    </Box>
                    : null
            }
        </Box>
    )

}

export const DashboardPannel = (props: { dashboard: Dashboard, isFullscreen: boolean }) => {

    const { dashboard, isFullscreen } = props
    return (
        <>
            {dashboard.embedMode === 2 || dashboard.embedMode === 1 ? <IframeDashboard dashboard={dashboard} isFullscreen={isFullscreen} /> : null}
            {dashboard.embedMode === 0 ? <EmbedDashboard dashboard={dashboard} isFullscreen={isFullscreen} /> : null}
        </>
    )
}